import {RouteConfig} from "./ui/RouterConfig";
import AppRouter from "./ui/AppRouter";
export { RouteConfig, AppRouter };